import { useEffect, useRef, useState } from "react";
import SidebarAdmin from "./sidebar-admin";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../config";

const EditClient = () => {
  const { id } = useParams<{ id: string }>();

  const [files, setFiles] = useState<File[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    type: "individual",
    companyName: "",
    country: "",
    email: "",
    phone: "",
    address: ""
  });

  const navigate = useNavigate();

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${API_URL}/client/${id}`)
      .then((response) => {
        console.log("responsee", response);

        const client = response.data.data;
        if (!client) {
          console.error("client data is undefined");
          return;
        }

        setFormData({
          firstname: client.firstname || "",
          lastname: client.lastname || "",
          email: client.email || "",
          address: client.address || "",
          country: client.country || "",
          phone: client.phone || "",
          type: client.type || "individual",
          companyName: client.company_name || ""
        });
      })
      .catch((error) => {
        console.error("Erreur loading client :", error);
      });
  }, [id]);

  const getFullName = () => {
    if (formData.firstname && formData.lastname) {
      return `${formData.firstname} ${formData.lastname}`;
    } else if (formData.firstname) {
      return formData.firstname;
    } else if (formData.lastname) {
      return formData.lastname;
    } else {
      return "Client";
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const clientData = {
        firstname: formData.firstname,
        lastname: formData.lastname,
        type: formData.type,
        country: formData.country,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        company_name: formData.type === "company" ? formData.companyName : null
      };

      const response = await axios.put(`${API_URL}/client/${id}`, clientData);
      navigate("/admin/list-clients");
      toast.success("Customer updated successfully");

    } catch (error: any) {
      console.error("Error in update customer :", error);
      
      if (error.response?.data?.errors) {
        const validationErrors = error.response.data.errors;
        Object.keys(validationErrors).forEach(field => {
          toast.error(`${field}: ${validationErrors[field][0]}`);
        });
      } else {
        toast.error(error.response?.data?.message || 'Error updating client');
      }
    }
  };

  const handleCancel = () => {
    navigate("/admin/list-clients");
  };

  return (
    <>
      <div className="dashboard-layout">
        <aside className="dashboard-sidebar">
          <SidebarAdmin />
        </aside>

        <div className="dashboard-main">
          <header className="dashboard-header">
            <div className="header-content">
              <button className="menu-toggle">
                <i className="icon-menu-2 text-20"></i>
              </button>
            </div>
          </header>

          <main className="dashboard-content">
            <div className="dashboard__content bg-light-2">
              {/* Header amélioré */}
              <div className="row y-gap-20 justify-between items-center pb-10 lg:pb-30 md:pb-20">
                <div className="col-12">
                  <h1 className="text-24 fw-600" style={{ color: '#1e293b' }}>Edit Client</h1>
                  <p className="text-14 mt-5" style={{ color: '#64748b' }}>
                    Update client profile: <span className="fw-500">{getFullName()}</span>
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="py-30 px-30 rounded-4 bg-white shadow-3 mb-3">
                  <div className="col-xl-12">
                    <div className="row x-gap-20 y-gap-20">
                      {/* Type Select */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Client Type *</label>
                        <div className="form-input">
                          <select 
                            name="type"
                            value={formData.type}
                            onChange={handleInputChange}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: 'white',
                              cursor: 'pointer',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          >
                            <option value="individual">Individual</option>
                            <option value="company">Company</option>
                          </select>
                        </div>
                      </div>

                      {/* Company Name (conditionnel) */}
                      {formData.type === "company" && (
                        <div className="col-md-6 col-12">
                          <label className="text-14 fw-500 text-dark-1 mb-8">Company Name *</label>
                          <div className="form-input">
                            <input 
                              type="text" 
                              name="companyName"
                              placeholder="Enter company name" 
                              value={formData.companyName}
                              onChange={handleInputChange}
                              required
                              style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px',
                                fontSize: '14px',
                                backgroundColor: '#f8fafc',
                                transition: 'all 0.2s'
                              }}
                              onFocus={(e) => {
                                e.target.style.backgroundColor = '#ffffff';
                                e.target.style.borderColor = '#3b82f6';
                                e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                              }}
                              onBlur={(e) => {
                                e.target.style.backgroundColor = '#f8fafc';
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Firstname */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">First Name *</label>
                        <div className="form-input">
                          <input 
                            type="text" 
                            name="firstname"
                            placeholder="Enter first name" 
                            value={formData.firstname}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>

                      {/* Lastname */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Last Name *</label>
                        <div className="form-input">
                          <input 
                            type="text" 
                            name="lastname"
                            placeholder="Enter last name" 
                            value={formData.lastname}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Email *</label>
                        <div className="form-input">
                          <input 
                            type="email" 
                            name="email"
                            placeholder="Enter email address" 
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Phone *</label>
                        <div className="form-input">
                          <input 
                            type="tel" 
                            name="phone"
                            placeholder="Enter phone number" 
                            value={formData.phone}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>

                      {/* Address */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Address *</label>
                        <div className="form-input">
                          <input 
                            type="text" 
                            name="address"
                            placeholder="Enter address" 
                            value={formData.address}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>

                      {/* Country */}
                      <div className="col-md-6 col-12">
                        <label className="text-14 fw-500 text-dark-1 mb-8">Country *</label>
                        <div className="form-input">
                          <input 
                            type="text" 
                            name="country"
                            placeholder="Enter country" 
                            value={formData.country}
                            onChange={handleInputChange}
                            required
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '1px solid #e2e8f0',
                              borderRadius: '8px',
                              fontSize: '14px',
                              backgroundColor: '#f8fafc',
                              transition: 'all 0.2s'
                            }}
                            onFocus={(e) => {
                              e.target.style.backgroundColor = '#ffffff';
                              e.target.style.borderColor = '#3b82f6';
                              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.target.style.backgroundColor = '#f8fafc';
                              e.target.style.borderColor = '#e2e8f0';
                              e.target.style.boxShadow = 'none';
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="py-30 px-30 mb-3 rounded-4 bg-white shadow-3">
                  <div className="d-flex justify-end">
                    <button 
                      type="button"
                      onClick={handleCancel}
                      className="px-20 py-10 text-white rounded-4" 
                      style={{
                        backgroundColor: "#6b7280", 
                        marginRight: "12px",
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s',
                        minWidth: '100px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#4b5563';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#6b7280';
                      }}
                    >
                      Cancel
                    </button>
                    <button 
                      type="submit" 
                      className="px-20 py-10 bg-blue-1 text-white rounded-4"
                      style={{
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s',
                        minWidth: '100px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#1d4ed8';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#3b82f6';
                      }}
                    >
                      Update Client
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </main>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default EditClient;